import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addProductPackageApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const addProductPackage = createAsyncThunk('addProductPackage', async (payload) => {
  return await addProductPackageApi(payload);
});

const addProductPackageSlice = createSlice({
  name: 'addProductPackage', // Unique Name
  initialState,
  reducers: {
    addProductPackageReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addProductPackage.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(addProductPackage.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(addProductPackage.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { addProductPackageReset } = addProductPackageSlice.actions;

export default addProductPackageSlice.reducer;
